module.exports = __webpack_public_path__ + "img/logoArgus.3c22d57a.png";